export const TIME_MORNING = 'MORNING';
export const TIME_AFTERNOON = 'AFTERNOON';
